
import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { formatValue, perfColor, perfPct } from '../utils/formatters';

const KPIGrid = ({ kpiSummary }) => {
  const getIcon = (actual, target) => {
    if (!actual || !target) return <Minus className="w-4 h-4 text-gray-400" />;
    return actual >= target
      ? <TrendingUp className="w-4 h-4 text-green-600" />
      : <TrendingDown className="w-4 h-4 text-red-600" />;
  };

  return (
    <div height="0"></div>

  );
};

export default KPIGrid;
